import { getId } from '/b2b/authentication/state/user/AuthUser.selectors';
import { getUrlParams } from '/b2b/common/state/selectors';
import { isLoading } from '/b2b/authentication/state/Auth.selectors';
import { onSendResetCode } from './ForgotPassword.commands';

export const mapStateToProps = state => {
    return {
        isLoading: isLoading(state),
        username: getUrlParams(state, 'email') || getId(state),
    };
};

export const mapDispatchToProps = { onSendResetCode };
